// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultHeading_root__BlPQS","titleWrapper":"DefaultHeading_titleWrapper__7tCX2"};